  import { formatDateUTCBr } from "@utils";
import { INotification } from "../../../providers/NotificationProvider";

const NotificationPackagesReceivedQuestionItem = ({
  createdAt,
  packageName,
}: INotification) => {
  return (
    <div className="padding-y-15 padding-x-25 width-100pct">
      <div>
        <span className="text-size-12 text-color-dark text-bold line-height-20">Pacotes</span>
      </div>

      <div className="display-flex align-items-center gap-15 padding-y-10">
        <div className="bg-primary width-40 height-40 display-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style={{ minWidth: '40px', minHeight: '40px' }}>
          <span className="rioglyph rioglyph-palette text-size-h4 text-color-white" />
        </div>

        <div className="flex-grow-1 overflow-hidden">
          <div className="display-flex gap-10 align-items-center">
            <span className="text-bold text-size-14 text-color-primary">
              Você já recebeu o pacote?
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-8">
            <span className="rioglyph rioglyph-box text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal word-break-word">
              Você já recebeu o pacote '{packageName || "Pacote"}' que estava esperando?
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-4">
            <span className="rioglyph rioglyph-calendar text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal">
              {formatDateUTCBr(createdAt)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPackagesReceivedQuestionItem;

